jQuery(function ($) {
    $(document).ready(function() {
        if ($('#commentform #email').length) {

            $.ajax( {
                url      : themevars.ajaxurl,
                data     : {
                    action: 'comment_account_email',
                    cac_nonce: themevars.cac_nonce
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( response ) {
    
                if (true !== response.success) {
                    return;
                }
    
                if (response.data.is_logged_in && response.data.emailaddress) {
                    // set emailaddress as value of comment email field and set field to disabled
                    $('#commentform #email').val(response.data.emailaddress);
                    $("#commentform #email").prop("readonly", true);
                }
            });
        }
    });
});
